<template>
  <div class="enterprise-detail-page">
        <PageHeader icon="far fa-check-circle">
      <template #title>
        Detail Status Perjanjian
      </template>
      <template #subtitle>
        Informasi lengkap mengenai status alur perjanjian
      </template>
      <template #actions>
        <div class="d-flex mt-4 mt-md-0" v-if="btn">
                <b-button @click="$router.push({path: '/masters/appointment-statuses/edit/' + data.id})" variant="light-primary" class="font-weight-bold px-6 mr-3">
                  <i class="fas fa-edit mr-2"></i>Edit Status
                </b-button>
                <b-button v-if="data.id > 5" @click="deleteData" variant="danger" class="font-weight-bold px-6">
                  <i class="fas fa-trash-alt mr-2"></i>Hapus
                </b-button>
              </div>
      </template>
    </PageHeader>

    <div class="card card-custom gutter-b border-0 shadow-sm">
      <div class="card-body p-8">
        <div class="row">
          <div class="col-lg-12">
            <div>
              <h5 class="text-dark font-weight-bolder mb-6 border-bottom pb-4">Informasi Status</h5>
              
              <div class="d-flex flex-column mb-6">
                <span class="text-muted font-weight-bold mb-3 text-uppercase" style="letter-spacing: 0.5px; font-size: 11px;">Pratinjau Label (Chip)</span>
                <div>
                  <button type="button" class="calendar-status-chip" :class="getChipClass(data.color_class)" style="pointer-events: none; margin: 0; box-shadow: none;">
                    <i v-if="getChipIcon(data.color_class)" :class="getChipIcon(data.color_class)"></i>
                    <span>{{ data.name || 'Pratinjau' }}</span>
                  </button>
                </div>
              </div>

              <div class="row mb-6">
                <div class="col-md-6 mb-4 mb-md-0">
                  <span class="text-muted font-weight-bold d-block mb-1 text-uppercase" style="letter-spacing: 0.5px; font-size: 11px;">Nama Status</span>
                  <span class="text-dark font-weight-bolder font-size-h5">{{ data.name }}</span>
                </div>
                <div class="col-md-6">
                  <span class="text-muted font-weight-bold d-block mb-1 text-uppercase" style="letter-spacing: 0.5px; font-size: 11px;">ID Status</span>
                  <span class="text-dark font-weight-bolder font-size-h5">#{{ data.id || $route.params.id }}</span>
                </div>
              </div>

              <div>
                <span class="text-muted font-weight-bold d-block mb-2 text-uppercase" style="letter-spacing: 0.5px; font-size: 11px;">Deskripsi & Penggunaan</span>
                <p class="text-dark-75 font-weight-bold font-size-lg" style="line-height: 1.6; background: #f8fafc; padding: 16px; border-radius: 8px;">
                  {{ data.description || 'Tidak ada deskripsi yang ditambahkan untuk status ini.' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data() {
    return {
      // Data
      data: {
        name: "",
        description: "",
        color_class: ""
      },
      // user access
      btn: false,
    }
  },

  components: {
    Card,
  },

  methods: {
    getChipClass(colorClass) {
      if (!colorClass) return 'calendar-status-chip--primary';
      if (colorClass.includes('primary')) return 'calendar-status-chip--primary';
      if (colorClass.includes('warning')) return 'calendar-status-chip--warning';
      if (colorClass.includes('success')) return 'calendar-status-chip--success';
      if (colorClass.includes('info')) return 'calendar-status-chip--info';
      if (colorClass.includes('danger')) return 'calendar-status-chip--danger';
      return 'calendar-status-chip--primary';
    },

    getChipIcon(colorClass) {
      if (!colorClass) return 'far fa-dot-circle';
      if (colorClass.includes('primary')) return 'far fa-dot-circle';
      if (colorClass.includes('warning')) return 'fas fa-exclamation-triangle';
      if (colorClass.includes('success')) return 'far fa-check-circle';
      if (colorClass.includes('info')) return 'far fa-paper-plane';
      if (colorClass.includes('danger')) return 'far fa-times-circle';
      return 'far fa-dot-circle';
    },

    async deleteData() {
      let result = await module.delete('appointment-statuses/' + this.$route.params.id)
      // If Deleted
      if (result) {
        // Redirect To List
        this.$router.push('/masters/appointment-statuses/list')
      }
    },

    async get() {
      this.data = await module.get('appointment-statuses/' + this.$route.params.id)
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push('/masters/appointment-statuses/list')
      }
    },

    setActiveButton(){
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for(a = 0; a < access_right.length; a++){
        if(access_right[a] == "1802"){
          this.btn = true
        }
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Status Perjanjian", route: "" },
      { title: "Daftar Status Perjanjian", route: "/masters/appointment-statuses/list" },
      { title: "Detail" },
    ])
    // Get Data
    this.get()
    this.setActiveButton()
  }
}
</script>